export const featuredProjects= [
    {
        id: 1,
        title: 'Experiments',
        image: 'https://bafybeidr4pxauxpo5b7pgxlmd4ynvvtg7u6qfrugoxp7ahktdt2aum2gwy.ipfs.nftstorage.link/',
        description: `Experiments are bringing a unique spin to twisted PFPs. On top of insane artwork, we strive to create an Empire. Our focus is to branch out to further corners than just the NFT space. And We want to create a massive brand that's not afraid to try new things.`,
        website: 'https://www.experimentsnft.io/'
    },

    {
        id: 2,
        title: 'MXXN WRLD',
        image: 'https://bafybeibbrkzuyqsqviqsb3drwx227evyplafdlepeldhnfwom5vugqjnme.ipfs.nftstorage.link/',
        description: `MXXN WRLD is a premier multi-niche company launching exclusively on Solana. Through beautiful unique art exclusive Web2 & Web3 partnerships, MXXN WRLD aims to bring significant holder value while developing a sustainable multi-niche business.`,
        website: 'https://www.mxxnwrld.xyz/'
    },
    
]